import React, { useState } from "react";
import "./feedback.css";

const FeedbackPopup = ({ onClose, onSubmit, isPaymentFeedback = false }) => {
  const [rating, setRating] = useState(5);
  const [hovered, setHovered] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
  const [customReason, setCustomReason] = useState("");
  const [submitted, setSubmitted] = useState(false); // ✅ New state

  const paymentReasons = [
    "I want to talk to someone to understand Tutor Verification",
    "I want other Payment options",
    "I find Tutor Verification plan too expensive",
    "I am not interested anymore",
    "My reason is not listed",
  ];

  const handleSubmit = () => {
    if (isPaymentFeedback) {
      const reasonToSubmit = selectedReason === "My reason is not listed" ? customReason : selectedReason;

      if (!reasonToSubmit || reasonToSubmit.trim() === "") {
        alert("Please select or write a reason before submitting.");
        return;
      }

      onSubmit({
        user_type: "TUTOR",
        feedback: reasonToSubmit,
        need_help: reasonToSubmit,
        customText: feedback ?? null,
      });
      setSubmitted(true); // ✅ show success message
    } else {
      if (rating === 0) {
        alert("Please select a rating.");
        return;
      }

      onSubmit({ user_type: "TUTOR", rating, feedback });
      setSubmitted(true); // ✅ show success message
    }
  };

  return (
    <div className="feedback-overlay" onClick={onClose}>
      <div className="feedback-popup" onClick={(e) => e.stopPropagation()}>
        <button className="feedback-close-btn" onClick={onClose}>
          ×
        </button>

        {/* ✅ Show submitted message if feedback is submitted */}
        {submitted ? (
          <div className="feedback-submitted">
            <h3>🎉 Thank you for your feedback!</h3>
            <p>Your response has been recorded successfully.</p>
            <button className="feedback-submitted-close-btn" onClick={onClose}>
              Close
            </button>
          </div>
        ) : (
          <>
            {isPaymentFeedback ? (
              <>
                <div className="feedback-title">
                  Kindly share your reason for not buying the HomeShiksha Verified Tutor <b>Subscription</b>.
                </div>
                <div className="feedback-radio-group">
                  {paymentReasons.map((reason, index) => (
                    <label key={index} className="feedback-radio-option">
                      <input
                        type="radio"
                        name="payment-reason"
                        value={reason}
                        checked={selectedReason === reason}
                        onChange={() => setSelectedReason(reason)}
                      />
                      {reason}
                    </label>
                  ))}
                </div>
                {selectedReason === "My reason is not listed" && (
                  <div className="feedback-custom-reason">
                    <label>Kindly mention your reason below</label>
                    <textarea
                      className="feedback-textarea"
                      placeholder="Type here"
                      value={customReason}
                      onChange={(e) => setCustomReason(e.target.value)}
                    />
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="feedback-title">Share your experience</div>
                <div className="feedback-stars">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <img
                      key={star}
                      src={
                        hovered >= star || rating >= star
                          ? "./star-feedback-icon-selected.svg"
                          : "./star-feedback-icon.svg"
                      }
                      alt="star icon"
                      className={`star-img ${hovered >= star || rating >= star ? "filled" : ""}`}
                      onMouseEnter={() => setHovered(star)}
                      onMouseLeave={() => setHovered(0)}
                      onClick={() => setRating(star)}
                    />
                  ))}
                </div>
                <label className="feedback-label">Do you have any thoughts or suggestions you’d like to share?</label>
                <textarea
                  className="feedback-textarea"
                  placeholder="Type here"
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                />
              </>
            )}

            <button className="feedback-submit-btn" onClick={handleSubmit}>
              Submit
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default FeedbackPopup;
